module.exports = __webpack_public_path__ + "img/sand-decal-10.b656a446.png";